module.exports = __webpack_public_path__ + "img/Rectangle 1212 (7).c715da5d.png";